import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import klerData from "../../apis/klerData";

class DeleteRecord extends React.Component {
  render() {
    const deleteRecord = formValues => {
      // **************************
      // DELETE GROUP
      klerData
        .delete(`/UserAccess(${formValues.Oid})`)
        .then(result => {
          this.props.handleCloseReload();
        })
        .catch(error =>
          this.setState({
            error
          })
        );
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      deleteRecord(formValues);
    };
    return (
      <div className="txt-center">
        <div>Are you sure you want to delete?</div>
        <div>
          <h4>{this.props.data.Email}</h4>
        </div>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Confirm
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      Oid: ownProps.data.Oid
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "DeleteRecord"
  })(DeleteRecord)
);
